import React, { useState } from 'react';
import {
  Modal,
  Text,
  BlockStack,
} from '@shopify/polaris';

const DeleteStoryModal = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  isDeleting 
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={<div style={{padding: '16px'}}>{'Confirm Deletion'}</div>}
      primaryAction={{
        content: 'Delete',
        onAction: onConfirm,
        loading: isDeleting,
        destructive: true,
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: onClose,
        },
      ]}
      footer={<div style={{padding: '16px'}}></div>}
    >
      <BlockStack gap="400">
        <Text>Are you sure you want to delete this story? This action cannot be undone.</Text>
      </BlockStack>
    </Modal>
  );
};

export default DeleteStoryModal; 